module.exports = __webpack_public_path__ + "img/banner1-titlesmall.1a0512e9.png";